import React from 'react';
import { TrendingUp } from 'lucide-react';
export function Header() {
  return <div className="bg-[#3d3d3d] border-b-4 border-[#c9a84c] w-full shadow-md" data-id="element-162">
      <div className="px-4 py-4" data-id="element-163">
        <div className="flex items-center gap-4 mb-1" data-id="element-164">
          <div className="bg-[#c9a84c] p-2 rounded-full text-white shadow-sm" data-id="element-165">
            <TrendingUp size={24} strokeWidth={2.5} data-id="element-166" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-white tracking-tight" data-id="element-167">
            Lead → Funded Throughput
          </h1>
        </div>
        <p className="text-sm text-gray-400 ml-14 opacity-90" data-id="element-168">
          Cohort analysis of lead conversion performance
        </p>
      </div>
    </div>;
}